import React from 'react';
import { FormControlLabel, makeStyles, Radio, RadioGroup } from '@material-ui/core';
import { PropTypes } from 'prop-types';

const styles = makeStyles({
    radio: {
        '&$checked': {
            color: '#509ffa'
        }
    },
    checked: {}
});
const RadioButton = ({ value, groupValue, handleChange, label }) => {
    const classes = styles();
    return (
        <>
            <RadioGroup value={groupValue} onChange={handleChange}>
                <FormControlLabel
                    value={value}
                    control={
                        <Radio
                            classes={{ root: classes.radio, checked: classes.checked }}
                            color="success"
                        />
                    }
                    label={label}
                    style={{ marginLeft: '0' }}
                />
            </RadioGroup>
        </>
    );
};
RadioButton.propTypes = {
    value: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    groupValue: PropTypes.string,
    handleChange: PropTypes.function
};

export default RadioButton;
